import React from "react"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import ReactHtmlParser from "react-html-parser"

export default function UniverseLandingPageHeroComponent({ heroImage, heroImageAltText, opacity, fontColor, infoHead, heading, subtext }) {
  const headingHtml = ReactHtmlParser(heading)
  const fontColorSelected = SelectionFactoryHelper.getFromSelectionFactory(fontColor)
  //opacity settings are based on the font color style selected in the CMS.
  //opacityFilterSettings is passed as a scss variable to the stylesheet.
  const opacityFilterSettings = fontColorSelected == "cph-white" ? `rgba(7, 17, 67, ${opacity})` : `rgba(255, 255, 255, ${opacity})`

  return (
    <div className="universe-landing-page-hero-container">
      <div className="image-container" style={{ "--opacitysettings": opacityFilterSettings }}>
        <img src={heroImage} alt={heroImageAltText} />
        <div className={`content ${fontColorSelected}`}>
          <p className="infohead-inverted">{infoHead}</p>
          <div className="universe-hero-heading">{headingHtml}</div>
          <p className="universe-hero-subtext">{subtext}</p>
        </div>
      </div>
    </div>
  )
}
